export enum FileType {
    NA = "na",
    Pdf = "pdf",
    Excel = "excel",
    Word = "word",
    Image = "image"
}
